import BrandCard from '@/app-theme/views/home/BrandCard.vue'
import StoreCommon from '@/app-core/mixins/store/storeCommon'

export default {
  name      : 'BrandSlider',
  components: {
    BrandCard
  },
  directives: {},
  mixins    : [StoreCommon],
  props     : {
    title: {
      type   : String,
      default: ''
    },

    titleClass: {
      type   : String,
      default: 'text-sm-h5 text-body-1 font-weight-bold'
    },

    stores: {
      type   : Array,
      default: () => []
    },

    dense: {
      type   : Boolean,
      default: false
    }
  },
  enums: {},
  data() {
    return {
      hasPrev: false,
      hasNext: false
    }
  },
  computed: {
    storesFiltered() {
      return this.stores //?.filter(store => !this.storeIsClosed(store)) || []
    },

    cardWidth() {
      if (this.$vuetify.breakpoint.xs) return this.dense ? 120 : 120
      if (this.$vuetify.breakpoint.sm) return this.dense ? 120 : 120
      if (this.$vuetify.breakpoint.md) return this.dense ? 120 : 150
      if (this.$vuetify.breakpoint.lg) return this.dense ? 120 : 180

      return this.dense ? 120 : 230
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
    this.$watch(() => this.$refs.categoriesSlideGroup.hasPrev, (newValue) => {
      this.hasPrev = newValue
    })
    this.$watch(() => this.$refs.categoriesSlideGroup.hasNext, (newValue) => {
      this.hasNext = newValue
    })
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    /**
     * onAffixClick
     *
     * @param location {String}
     */
    onAffixClick(location) {
      this.$refs.categoriesSlideGroup.onAffixClick(location)
    },

    onItemClick(store) {
      if (this.$route.name === 'Store') {
        this.$bus.$emit('store:selected', store)
      } else {
        this.$router.push({
          name  : 'Store',
          params: {
            slug: store.Slug,
            id  : store.Id
          }
        })
      }
    }
  }
}
